import { Component } from 'react';
import BrowserRoutes from './core/components/molecules/browser-routes';
import { Routes } from './routes';

export default class App extends Component {
  public render() {
    return <BrowserRoutes routes={Routes} />;
  }
}
